import script from "./LeftSection.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftSection.vue?vue&type=script&setup=true&lang=js"

import "./LeftSection.vue?vue&type=style&index=0&id=aea9d670&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aea9d670"]])

export default __exports__